import { handleInputChange } from 'components/global/_helpers/global.helpers';
import ProfileImageUpload from 'components/global/ProfileImageUpload';
import UniversalInput from 'components/global/UniversalInput/UniversalInput';
import { handleProfileImageRemove, handleProfileImageUpload, handleSubmitEditInvestorProfile } from 'components/views/InvestorEditProfile/_helpers/investorEditProfile.events';
import { fetchAndSetInvestorProfileData } from 'components/views/InvestorEditProfile/_helpers/investorEditProfile.resolvers';
import { ORGANIZATION_ROLES_OPTIONS } from 'constants/globalConstants';
import withDismount from 'hocs/withDismount';
import { Button, Col, Row } from 'react-bootstrap';
import { $form, $view, $user } from 'signals/global.signals';
import { useEffectAsync } from 'utils/useEffectAsync';

const InvestorEditProfile = () => {
  useEffectAsync(fetchAndSetInvestorProfileData);

  return (
    <>
      <Row className="mb-32">
        <Col>
          <div className="d-flex flex-md-row flex-column align-items-center">
            <div>
              <ProfileImageUpload
                entityId={$user.value.id}
                currentImage={$form.value.profileImage}
                defaultName={$form.value.firstName}
                avatarColors={$form.value.avatarColors}
                onImageUpload={handleProfileImageUpload}
                onImageRemove={handleProfileImageRemove}
                uploadPath="profile-assets"
              />
            </div>
            <div className="d-flex flex-column ms-md-32 ms-0 align-items-md-start align-items-center">
              <div>
                <span className="d-block h3 fw-600">{$view.value.firstName} {$view.value.lastName}</span>
                <span className="text-info d-block">{$view.value.email}</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="gx-xl-24 gx-md-16 gx-24 gy-lg-16 gy-16">
        <Col lg={6} md={6}>
          <UniversalInput
            name="firstName"
            label="First Name"
            required
          />
        </Col>
        <Col lg={6} md={6}>
          <UniversalInput
            name="lastName"
            label="Last Name"
          />
        </Col>
        <Col lg={6}>
          <UniversalInput
            name="age"
            label="Age Range"
            type="select"
            options={$view.value.ageOptions || []}
          />
        </Col>
        <Col lg={6}>
          <UniversalInput
            name="gender"
            label="Gender"
            type="select"
            options={$view.value.genderOptions || []}
          />
        </Col>
        <Col lg={6}>
          <UniversalInput
            name="ethnicity"
            label="Ethnicity"
            type="select"
            options={$view.value.ethnicityOptions || []}
          />
        </Col>
        <Col xl={6} lg={6}>
          <UniversalInput
            name="levelOfEducation"
            label="Level of Education"
            type="text-input"
          />
        </Col>
        <Col xl={6} lg={6}>
          <UniversalInput
            name="undergraduateUniversity"
            label="Undergraduate University"
            type="text-input"
          />
        </Col>
        <Col xl={6} lg={6}>
          <UniversalInput
            name="graduateUniversity"
            label="Graduate University"
            type="text-input"
          />
        </Col>
        <Col lg={8}>
          <UniversalInput
            isMulti
            name="roles"
            label="Organization Roles (Select All That Apply)"
            type="select"
            value={ORGANIZATION_ROLES_OPTIONS.filter(option => $form.value.roles?.includes(option.value))}
            options={ORGANIZATION_ROLES_OPTIONS}
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
              handleInputChange({ name: 'roles', value: selectedValues });
            }}
          />
        </Col>
      </Row>
      <Row className="mt-24">
        <Col>
          <div className="d-flex gap-16">
            <Button
              className="fw-600 px-24 py-8"
              onClick={handleSubmitEditInvestorProfile}
              disabled={$view.value.isFormSaving}
            >
              Save Changes
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default withDismount(InvestorEditProfile);
